/* projects/speaker-platform/src/app/atoms/card-with-header/card-with-header.component.scss */
.cardwheader__header {
  padding: 8px 16px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.cardwheader__header--headeronly {
  border-radius: 5px;
}
.cardwheader__header--info {
  color: #dadada;
  background-color: #74E4FD;
}
.cardwheader__header--primary {
  color: #968C00;
  background-color: #FFED00;
}
.cardwheader__header--warning {
  color: #9A7407;
  background-color: #FFC107;
}
.cardwheader__header--danger {
  color: #952626;
  background-color: #FF7474;
}
.cardwheader__header--success {
  color: #289526;
  background-color: #99FF74;
}
.cardwheader__header--disabled {
  color: #575757;
  background: #ADADAD;
}
.cardwheader__body {
  padding: 16px;
  background-color: #FAF8F4;
}
/*# sourceMappingURL=card-with-header.component-CNNIHD2T.css.map */
